import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CustomerListComponent} from "../customer-list/customer-list.component";
import {InvoiceListComponent} from "../invoice-list/invoice-list.component";
import {CustomerFormComponent} from "../customer-form/customer-form.component";
import {InvoiceFormComponent} from "../invoice-form/invoice-form.component";
import {PaymentListComponent} from "../payment-list/payment-list.component";
import {PaymentFormComponent} from "../payment-form/payment-form.component";
import {TriggerStatementsComponent} from "../trigger-statements/trigger-statements.component";

const routes: Routes = [
  { path: 'customers', component: CustomerListComponent },
  { path: 'customers/:id', component: CustomerListComponent },
  { path: 'customerForm/:action/:customerId', component: CustomerFormComponent },
  { path: 'invoiceForm/:action/:customerId/:id', component: InvoiceFormComponent },
  { path: 'invoices/:action/:customerId/:id', component: InvoiceListComponent },
  { path: 'invoiced/:action/:customerId/:id', component: InvoiceListComponent },
  { path: 'allInvoices/:action/:customerId/:id', component: InvoiceListComponent },
  { path: 'invoice/:action/:customerId/:id', component: InvoiceListComponent },
  { path: 'allPayments/:action/:customerId/:invoiceId/:id', component: PaymentListComponent },
  { path: 'payments/:action/:customerId/:invoiceId/:id', component: PaymentListComponent },
  { path: 'paymentd/:action/:customerId/:invoiceId/:id', component: PaymentListComponent },
  { path: 'payment/:action/:customerId/:invoiceId/:id', component: PaymentListComponent },
  { path: 'paymentForm/:action/:customerId/:invoiceId/:id', component: PaymentFormComponent },
  { path: 'statements', component: TriggerStatementsComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing/app-routing.module.ts